function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectPlaceholder = _ref => {
  var {
    innerProps,
    children,
    selectProps
  } = _ref;
  var styles = useMultiStyleConfig('Select', {
    size: selectProps.size
  });
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "SelectPlaceholder",
    "aria-disabled": selectProps.isDisabled,
    __css: styles['placeholder']
  }, innerProps), {}, {
    children: children
  }));
};
//# sourceMappingURL=SelectPlaceholder.js.map